module.exports = __webpack_public_path__ + "img/windscreen-air.bbc6e973.svg";